export default function Header({ tab, setTab, tabs, stats }) {
  return (
    <header className="glass sticky top-0 z-20">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between gap-6">
        <a href="/" className="flex items-center gap-3 group" data-testid="brand">
          <span className="text-2xl md:text-3xl leading-none select-none" aria-hidden="true">💎</span>
          <div className="leading-none">
            <div className="font-display text-2xl md:text-3xl tracking-tight flex items-center gap-2">
              <span className="gold">Gem</span>
              <span>Key</span>
              <span className="text-xl md:text-2xl select-none" aria-hidden="true">🔑</span>
            </div>
            <div className="font-mono text-[10px] tracking-[0.18em] muted uppercase mt-1.5">
              Decode by Number · {stats?.cipher_count || 0} Ciphers · {stats?.total_phrases || 0} Phrases
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {tabs.map((t) => (
            <button
              key={t.id}
              data-testid={t.testid}
              onClick={() => setTab(t.id)}
              className={`px-4 py-2 text-xs font-mono uppercase tracking-[0.14em] transition-colors ${
                tab === t.id
                  ? "text-[var(--primary)] border-b border-[var(--primary)]"
                  : "muted hover:text-[var(--text)] border-b border-transparent"
              }`}
            >
              {t.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Mobile nav with right-edge fade hint for scroll */}
      <div className="md:hidden relative border-t border-white/10">
        <div className="flex overflow-x-auto no-scrollbar">
          {tabs.map((t) => (
            <button
              key={t.id}
              data-testid={t.testid + "-mobile"}
              onClick={() => setTab(t.id)}
              className={`flex-shrink-0 px-4 py-3 text-[11px] font-mono uppercase tracking-[0.12em] whitespace-nowrap ${
                tab === t.id ? "text-[var(--primary)] bg-white/5 border-b border-[var(--primary)]" : "muted"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
        <div className="pointer-events-none absolute top-0 right-0 h-full w-8 bg-gradient-to-l from-[#0a0a0c] to-transparent" />
      </div>
    </header>
  );
}
